// useChat のメッセージ更新を UI へ反映する間隔 (ms)。
// 未指定だとチャンクごとに再レンダリングが走り、同一ドキュメント上のキャンバス操作までカクつく。
export const CHAT_STREAMING_THROTTLE_MS = 100;
